<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      tagOptions: [
        {
          label: 'h1',
          value: 'h1'
        },
        {
          label: 'h2',
          value: 'h2'
        },
        {
          label: 'h3',
          value: 'h3'
        },
        {
          label: 'h4',
          value: 'h4'
        },
        {
          label: 'h5',
          value: 'h5'
        },
        {
          label: 'h6',
          value: 'h6'
        }
      ]
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Content',
              modelPath: [this, 'form', 'content'],
              multilingual: true,
              required: true,
              useBr: true
            }),
            new fields.Select({
              label: 'Tag',
              modelPath: [this, 'form', 'tag'],
              options: this.tagOptions,
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
